export const ASC = "ASC";
export const DESC = "DESC";
export const IsPrevious = true;

// GAME_STATE contains all possible stages of game play
export const GAME_STAGE = {
  NOTHING: 0,
  PRESENTATION: 1,
  HISTORY_TAKING: 2,
  HISTORY_SUMMARY: 3,
  DIAGNOSIS_1: 4,
  EXAMINATION: 5,
  EXAMINATION_EVALUATION: 6,
  DIAGNOSIS_2: 7,
  INVESTIGATION: 8,
  INVESTIGATION_EVALUATION: 9,
  FINAL_DIAGNOSIS: 10,
  FINAL_DIAGNOSIS_EVALUATION: 11,
  MANAGEMENT: 12,
  MANAGEMENT_EVALUATION: 13,
  FINAL_MARKS: 14,
  CASE_SUMMARY: 15,
};

// GAME_STAGE_ACCESS contains all accessible stages for the users at different states
// 2, 4, 5, 7, 8, 10, 12, 14
export const GAME_STAGE_ACCESS = [
  [0],
  [1],

  [2],
  [3],
  [3, 4],

  [3, 4, 5],
  [3, 4, 6],
  [3, 4, 6, 7],

  [3, 4, 6, 7, 8],
  [3, 4, 6, 7, 9],

  [3, 4, 6, 7, 9, 10],
  [3, 4, 6, 7, 9, 11],

  [3, 4, 6, 7, 9, 11, 12],
  [3, 4, 6, 7, 9, 11, 13],

  [3, 4, 6, 7, 9, 11, 13, 14],
  [3, 4, 6, 7, 9, 11, 13, 14, 15],
];

export const GAME_STAGE_AWAIT = [
  [],
  [],

  [4, 5, 7, 8, 4, 10, 12, 14],
  [4, 5, 7, 8, 4, 10, 12, 14],
  [5, 7, 8, 10, 12, 14],

  [7, 8, 10, 12, 14],
  [7, 8, 10, 12, 14],
  [8, 10, 12, 14],

  [10, 12, 14],
  [10, 12, 14],

  [12, 14],
  [12, 14],

  [14],
  [14],

  [],
  [],
];

// Legacy [6 icons]
// e.g. first index - presentation state, second index - history taking state
// 2, 6, 9, 11, 13
// export const GAME_STAGE_ACCESS = [
//   [0],
//   [1],
//
//   [2],
//   [3],
//   [3, 4],
//
//   [3, 5],
//   [3, 6],
//   [3, 6, 7],
//
//   [3, 6, 8],
//   [3, 6, 9],
//
//   [3, 6, 9, 10],
//   [3, 6, 9, 11],
//
//   [3, 6, 9, 11, 12],
//   [3, 6, 9, 11, 13],
//
//   [3, 6, 9, 11, 13, 14],
//   [3, 6, 9, 11, 13, 14, 15],
// ];
//
// export const GAME_STAGE_AWAIT = [
//   [],
//   [],
//
//   [5, 8, 4, 12, 14],
//   [5, 8, 4, 12, 14],
//   [5, 8, 12, 14],
//
//   [8, 10, 12, 14],
//   [8, 10, 12, 14],
//   [8, 12, 14],
//
//   [10, 12, 14],
//   [10, 12, 14],
//
//   [12, 14],
//   [12, 14],
//
//   [14],
//   [14],
//
//   [],
//   [],
// ];


